import { render } from "./organization-update-sidebar.vue?vue&type=template&id=dea4d7a0"
import script from "./organization-update-sidebar.vue?vue&type=script&lang=js"
export * from "./organization-update-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__